export const prepareAccordionItems = (data) => {
  const items = [];

  // Кросс-продукты
  if (data.cross_products && data.cross_products.length > 0) {
    items.push({
      category: "Кросс-продукты",
      items: data.cross_products.map((p) => ({
        id: p.cross_id,
        name: p.title,
        openCount: p.crm,
        image: p.image,
      })),
    });
  }

  // Dropdowns
  if (data.dropdowns && data.dropdowns.length > 0) {
    data.dropdowns.forEach((d) => {
      items.push({
        id: d.id ?? Math.floor(Math.random() * 1e6),
        category: d.title,
        scripts: [d.description],
        isNew: false,
      });
    });
  }

  return items;
};

export const preparePatchPayload = (
  accordionItems,
  quantity,
  attributes,
  originalData
) => {
  const cross_products = originalData.cross_products || [];

  // --- DROPDOWNS LOGIC (only this part changed) ---
  const allDropdowns = accordionItems
    .filter((item) => item.scripts && item.scripts.length > 0)
    .map((item) => ({
      id: item.id ?? Math.floor(Math.random() * 1e6),
      title: item.category,
      description: item.scripts[0] || "",
      isNew: item.isNew ?? false,
    }));

  // множество id присутствующих сейчас дропдаунов
  const presentIds = new Set(allDropdowns.map((d) => d.id));

  // какие из оригинальных дропдаунов были удалены в UI
  const deleted_dropdowns = (originalData.dropdowns || [])
    .filter((od) => !presentIds.has(od.id))
    .map((od) => od.id);

  // определяем изменённые или новые дропдауны
  const changedDropdowns = allDropdowns.filter((nd) => {
    const original = (originalData.dropdowns || []).find(
      (od) => od.id === nd.id
    );

    // если нет оригинала — это новый
    if (!original) return true;

    // если изменены поля — это редактирование
    const edited =
      original.title !== nd.title || original.description !== nd.description;

    return edited;
  });

  // объединяем: берем оригиналы, но только те, которые не были удалены,
  // и применяем изменения к тем, которые были отредактированы
  const mergedDropdowns = (originalData.dropdowns || [])
    .filter((od) => presentIds.has(od.id)) // исключаем удалённые
    .map((od) => {
      const changed = changedDropdowns.find((cd) => cd.id === od.id);
      return changed ? { ...od, ...changed } : od;
    });

  // добавляем новые дропдауны (у которых нет id в originalData)
  changedDropdowns.forEach((cd) => {
    const exists = (originalData.dropdowns || []).some((od) => od.id === cd.id);
    if (!exists) mergedDropdowns.push(cd);
  });

  // --- REST OF LOGIC UNTOUCHED ---
  const preparedAttributes = attributes.map((attr) => {
    const originalAttr = originalData.attributes.find(
      (a) => a.name === attr.name
    );

    return {
      id: originalAttr?.id,
      name: attr.name,
      values: attr.variations.map((v) => {
        const originalValue = originalAttr?.values.find(
          (val) => val.value === v
        );
        return {
          id: originalValue?.id,
          value: v,
        };
      }),
    };
  });

  return {
    cross_products,
    quantity,
    attributes: preparedAttributes,
    dropdowns: mergedDropdowns,
  };
};

export const toFormData = (obj) => {
  const formData = new FormData();

  Object.entries(obj).forEach(([key, value]) => {
    if (value instanceof File || value instanceof Blob) {
      // Файл — добавляем напрямую
      formData.append(key, value);
    } else if (Array.isArray(value) || typeof value === "object") {
      // Объекты и массивы — как JSON
      formData.append(key, JSON.stringify(value));
    } else if (value !== undefined && value !== null) {
      // Простые значения
      formData.append(key, value);
    }
  });

  return formData;
};
